module.exports = __webpack_public_path__ + "img/FloorPlan.dc8cec8d.jpg";